import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseRequestOptions, HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MockBackend } from '@angular/http/testing';

import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { ResetPasswordRoutingModule } from './reset-password-routing.module';
import { ResetPasswordComponent } from './reset-password.component';
import { AlertModule, AlertComponent } from '../shared/alert';
import { AuthModule } from '../auth/auth.module';
import { AuthService } from './../_services';
//import { fakeBackendProvider } from './auth/_helpers';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
    declarations: [
        ResetPasswordComponent
    ],
    imports: [
        ResetPasswordRoutingModule,
        CommonModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        AlertModule,
        SweetAlert2Module.forRoot(),
        NgbModule,
        AuthModule

    ],
    providers: [
        AuthService,
        // api backend simulation
        MockBackend,
        BaseRequestOptions,
    ],
    entryComponents: [AlertComponent],
})

export class ResetPasswordModule {
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/reset-password/reset-password.module.ts